import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { financecommerceApi, type JournalVoucher } from '../../api/financecommerce';

export function TallySyncDashboardPage() {
  const [journals, setJournals] = useState<JournalVoucher[]>([]);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    void financecommerceApi.listJournals().then(setJournals);
  }, []);

  async function exportAll() {
    const ids = journals.map((j) => j.id);
    if (!ids.length) return;
    await financecommerceApi.tallyExport(ids);
    setMsg(`Exported ${ids.length} voucher(s) to Tally XML`);
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/finance" className="text-sm text-slate-600 hover:underline">← Finance hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Tally sync</h1>
      {msg && <p className="mt-2 text-sm text-green-700">{msg}</p>}
      <button type="button" onClick={() => void exportAll()} disabled={!journals.length}
        className="mt-4 rounded bg-slate-900 px-4 py-2 text-sm text-white disabled:opacity-50">Export to Tally</button>
    </div>
  );
}
